import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';
import type { Dayjs } from '@iqx-web/libs/dayjs';
import generatePicker from 'antd/lib/date-picker/generatePicker';
import type { DatePickerProps } from './types';
import { generateConfig } from '../dayjs.config';

const DatePicker = generatePicker<Dayjs>(generateConfig);

export const StyledDatePicker: StyledComponent<typeof DatePicker, DatePickerProps> = styled(
  DatePicker,
)``;
